import api from "../api/axiosInstance";

const currencyService = {
    listActive: () => api.get("/currencies"),
    listAll: () => api.get("/currencies/all"),
    create: (payload) => api.post("/currencies", payload),
    update: (id, payload) => api.patch(`/currencies/${id}`, payload),
    remove: (id) => api.delete(`/currencies/${id}`),
    reorder: (orderedIds) => api.patch("/currencies/reorder", { orderedIds }),
};

export default currencyService;
